//Generated File 
export const AllScreens = `AllScreens`;
export const Documents = `Documents`;
export const MasterFiles = `MasterFiles`;
